import React from "react";

/**
 * Twinbox brand wordmark — matches the website: "Twinbox" in Archivo black with an
 * orange period. Loads Archivo via index.html; falls back to the system stack.
 *
 * @param {number} size  font-size in px.
 */
export default function TwinboxWordmark({ size = 24, className = "" }) {
  return (
    <span
      className={className}
      role="img"
      aria-label="Twinbox"
      style={{
        fontFamily: 'Archivo, system-ui, -apple-system, "Segoe UI", sans-serif',
        fontWeight: 900,
        fontSize: `${size}px`,
        letterSpacing: "-0.02em",
        whiteSpace: "nowrap",
        display: "inline-flex",
        alignItems: "baseline",
        lineHeight: 1,
      }}
    >
      <span className="text-[#1a1a1f] dark:text-white">Twinbox</span>
      <span style={{ color: "#FF9F0A" }}>.</span>
    </span>
  );
}
